import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../assets/oj-logo.png'


const _hoisted_1 = { id: "contestlayout" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = ["src"]

import message from "@arco-design/web-vue/es/message";
import { useStore } from "vuex";
import { ref, watch, watchEffect } from "vue";
import AccessEnum from "@/access/AccessEnum";
import { useRoute, useRouter } from "vue-router";
import { LoginUserVO } from "../../generated/models/LoginUserVO";
import { UserControllerService } from "../../generated/services/UserControllerService";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContestLayout',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();

const loginUser = ref<LoginUserVO>();
watchEffect(() => {
  loginUser.value = store.state.user?.loginUser;
});

const logout = async () => {
  const res = await UserControllerService.userLogoutUsingPost();
  if (res.code === 0) {
    location.reload();
    message.success("退出成功");
  } else {
    message.error("退出失败，", res.message);
  }
};

const questionId = ref();
watch(
  () => route.params,
  () => {
    questionId.value = route.params.id;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_a_link = _resolveComponent("a-link")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_IconUser = _resolveComponent("IconUser")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_icon_user = _resolveComponent("icon-user")!
  const _component_a_anchor_link = _resolveComponent("a-anchor-link")!
  const _component_a_doption = _resolveComponent("a-doption")!
  const _component_icon_poweroff = _resolveComponent("icon-poweroff")!
  const _component_icon_import = _resolveComponent("icon-import")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, { style: {"min-height":"100vh"} }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "header" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, {
              class: "grid-demo",
              align: "center",
              wrap: false
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { flex: "auto" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_link, {
                          hoverable: false,
                          href: "/"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { flex: "100px" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_dropdown, { trigger: "hover" }, {
                      content: _withCtx(() => [
                        (loginUser.value && loginUser.value.userRole != _unref(AccessEnum).NOT_LOGIN)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createVNode(_component_a_doption, null, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_icon_user)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_anchor_link, { href: "/mine" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("个人信息")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_doption, null, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_icon_poweroff)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_anchor_link, { onClick: logout }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("退出登录")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_component_a_doption, null, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_icon_import)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_anchor_link, { href: "/user/login" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("登录")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_doption, null, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_icon_user)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_a_anchor_link, { href: "/user/register" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("注册")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ], 64))
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_a_avatar, {
                          shape: "circle",
                          class: "userAvatar"
                        }, {
                          default: _withCtx(() => [
                            (loginUser.value && loginUser.value.userRole != _unref(AccessEnum).NOT_LOGIN)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (loginUser.value.userAvatar)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        alt: "avatar",
                                        src: loginUser.value.userAvatar
                                      }, null, 8, _hoisted_3))
                                    : (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_IconUser)
                                        ]),
                                        _: 1
                                      }))
                                ], 64))
                              : (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("未登录")
                                  ]),
                                  _: 1
                                }))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_content, { class: "content" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})